export const PHONE_BREAKPOINT = 600 as const
export const TABLET_BREAKPOINT = 840 as const
export const DESKTOP_BREAKPOINT = 1100 as const
export const PUBLIC_PAGE_MAX_WIDTH = 960 as const
